<div class="paginator-wrapper" [class.hide-range-label]="true"
  [matTooltip]="hideRangeLabel && !counting ? rangeLabel : ''" matTooltipPosition="below" matTooltipShowDelay="600">
  <div class="paginator-controls">
    <span class="items-per-page-label" *ngIf="showPageSizeSelector">{{ 'label.itemsPerPageLabel' | translate }}:</span>

    <mat-form-field class="page-size-select no-hint" *ngIf="showPageSizeSelector">
      <mat-select [value]="pageSize" [disabled]="disabled || counting"
        (selectionChange)="pageSizeChange.emit($event.value)">
        <mat-select-trigger>
          <span style="font-size: 12px">{{ pageSize }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let option of pageSizeOptions" [value]="option">
          <span style="font-size: 12px">{{ option }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <span class="range-label" [class.counting]="counting">
      <ng-container *ngIf="counting; else showRange">
        {{ 'label.counting' | translate }}
      </ng-container>
      <ng-template #showRange>
        {{ rangeLabel }}
      </ng-template>
    </span>

    <mat-paginator class="responsive" (page)="emitPageChangeEvent($event)" [length]="length" [pageIndex]="currentPage"
      [pageSize]="pageSize" [pageSizeOptions]="[]" [hidePageSize]="true" [disabled]="disabled || counting">
    </mat-paginator>
  </div>
</div>
